import { Listbox, Transition } from '@headlessui/react';
import { FaChevronDown } from 'react-icons/fa';
import { twMerge } from 'tailwind-merge';

import { DropdownOption } from './DropdownOption';
import { DropdownProps, DropdownValue, DropdownOptionProps } from './types';

function Dropdown<T extends DropdownValue>({
  children,
  onChange,
  className,
  placeholder = 'Please Select',
  icon = null,
  disabled,
  optionsClassName,
  ...props
}: DropdownProps<T>) {
  return (
    <Listbox {...props} by="key" disabled={disabled} onChange={onChange as (value: T) => void}>
      {({ open, value }) => (
        <div className={twMerge('relative w-56', className)}>
          <Listbox.Button
            className={twMerge(
              'relative flex h-[40px] min-h-[40px] w-full items-center rounded-lg border border-neutral-300 bg-neutral-50 p-2.5 text-sm duration-300 ease-in-out',
              'focus-ring',
              disabled && 'cursor-not-allowed bg-neutral-300 text-white',
            )}
          >
            {icon}
            <span className="mr-3 w-full truncate text-left">{value?.value ?? placeholder}</span>
            <span className="pointer-events-none absolute right-2">
              <FaChevronDown className={disabled ? 'text-white' : 'text-neutral-400'} size={12} />
            </span>
          </Listbox.Button>
          <Transition show={open}>
            <Listbox.Options
              className={twMerge(
                'absolute z-50 mt-1 max-h-56 w-full cursor-pointer overflow-auto rounded-lg border border-neutral-300 bg-white p-2 focus:outline-none',
                optionsClassName,
              )}
            >
              {children}
            </Listbox.Options>
          </Transition>
        </div>
      )}
    </Listbox>
  );
}

Dropdown.Option = DropdownOption;

export type { DropdownValue, DropdownProps, DropdownOptionProps };

export { Dropdown };
